// extracted by mini-css-extract-plugin
export default {"tab-item-header":"TabItemHeader_tab-item-header__WjCMV","tab-item-header--selected":"TabItemHeader_tab-item-header--selected__SV3zl"};